import {Controller} from "stimulus";

let token = document.querySelector(
    'meta[name="csrf-token"]'
).content;
let timer;

// Connects to data-controller="check-timeout"
export default class extends Controller {
    connect() {
        // timer = setInterval(this.check_session, 1000)
        // setTimeout(this.check_session, 1000)
    }

    check_session() {

        fetch('/sessions/active', {
            method: 'GET',
        }).then((resp) => resp.json())
            .then(data => {

                    // fetch('/users/sign_out', {
                    //     method: "DELETE",
                    // })
                    //     .then((response) => {

                        // })
                        // .catch((error) => {
                        //     console.error("Error:", error);
                        // });
            })
            .catch(error => {
                clearInterval(timer);
                window.location.href = '/sign_ins/new';
            })

        // let expiry = sessionStorage.getItem('expires_at')
        // let d = new Date();
        // console.log(d);
        // if (parseInt(expiry) < parseInt(d)) {
        //     fetch('/users/sign_out', {
        //         method: "DELETE",
        //     })
        //         .then((response) => {
        //             window.location.href = '/sign_ins/new';
        //         })
        //         .catch((error) => {
        //             console.error("Error:", error);
        //         });
        // }
    }
}
